/* POSTIFULL - Sepet onerileri: "Ekle" butonu (LED aplik vb.) · 2026-10-20 · snippets/pf-cart-nudge.liquid */
(function () {
  'use strict';
  if (window.__pfCart) return;
  window.__pfCart = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pfc-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var card = b.closest('[data-pfc-card]');
    var inp = card && card.querySelector('[data-pfc-variant]');
    var id = inp && inp.value;
    if (!id) return;
    b.disabled = true;
    var txt = b.textContent;
    b.textContent = '…';
    fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {
      b.disabled = false;
      b.textContent = txt;
    });
  });
})();

/* POSTIFULL v67 (2026-10-23): sepet cekmecesi telefonda asagi kaydirinca kapanir.
   Basliktan ya da urun listesi en ustteyken asagi cekilince cekmece parmagi izler;
   90px'i (ya da hizli bir cekisi) gecince kapanir, gecmezse yerine doner. Dokunmalar/tiklamalar etkilenmez. */
(function () {
  'use strict';
  if (window.__pfCartSwipe) return;
  window.__pfCartSwipe = true;
  var mq = window.matchMedia('(max-width: 999px)');
  var st = null;

  function parts(d) {
    var sr = d.shadowRoot;
    return sr ? { content: sr.querySelector('[part="content"]'), body: sr.querySelector('[part="body"]'), overlay: sr.querySelector('[part="overlay"]') } : {};
  }
  function reset(p, animate) {
    if (!p.content) return;
    p.content.style.transition = animate ? 'transform .22s ease' : '';
    p.content.style.transform = '';
    if (p.overlay) { p.overlay.style.transition = animate ? 'opacity .22s ease' : ''; p.overlay.style.opacity = ''; }
    if (animate) setTimeout(function () { p.content.style.transition = ''; if (p.overlay) p.overlay.style.transition = ''; }, 260);
  }

  document.addEventListener('touchstart', function (e) {
    if (!mq.matches || e.touches.length !== 1) return;
    var d = e.target.closest && e.target.closest('cart-drawer');
    if (!d || !d.open) return;
    if (e.target.closest('input, textarea, select, cart-note-dialog')) return;
    var p = parts(d);
    if (!p.content) return;
    var inHead = !!e.target.closest('.cart-drawer__top');
    var atTop = !p.body || p.body.scrollTop <= 0;
    st = { d: d, p: p, y: e.touches[0].clientY, x: e.touches[0].clientX, t: Date.now(), ok: inHead || atTop, drag: false, dy: 0 };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!st || !st.ok) return;
    var dy = e.touches[0].clientY - st.y, dx = e.touches[0].clientX - st.x;
    if (!st.drag) {
      if (Math.abs(dy) < 8 && Math.abs(dx) < 8) return;
      if (dy <= 0 || Math.abs(dx) > Math.abs(dy)) { st = null; return; }
      st.drag = true;
    }
    st.dy = Math.max(0, dy);
    if (e.cancelable) e.preventDefault();
    st.p.content.style.transition = 'none';
    st.p.content.style.transform = 'translateY(' + st.dy + 'px)';
    if (st.p.overlay) st.p.overlay.style.opacity = String(Math.max(0.2, 1 - st.dy / 500));
  }, { passive: false });

  function end() {
    if (!st) return;
    var s = st; st = null;
    if (!s.drag) return;
    var fast = s.dy > 40 && (s.dy / Math.max(1, Date.now() - s.t)) > 0.6;
    if (s.dy > 90 || fast) {
      s.p.content.style.transition = 'transform .2s ease';
      s.p.content.style.transform = 'translateY(100%)';
      setTimeout(function () {
        if (s.d.hide) s.d.hide(); else s.d.removeAttribute('open');
        setTimeout(function () { reset(s.p, false); }, 400);
      }, 180);
    } else {
      reset(s.p, true);
    }
  }
  document.addEventListener('touchend', end, { passive: true });
  document.addEventListener('touchcancel', end, { passive: true });
})();
